const excludes = state => state.excludes

export default {
  excludes
}
